// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"437":"c5eba39b","913":"c5eba39b","933":"c5eba39b","982":"c5eba39b"}[chunkId] + ".chunk.css";
};